export default __webpack_public_path__ + "static/media/box_closed.edb9906e.png";